import { render, staticRenderFns } from "./BANANOFountainDescription.vue?vue&type=template&id=f3676126&scoped=true&"
import script from "./BANANOFountainDescription.vue?vue&type=script&lang=js&"
export * from "./BANANOFountainDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3676126",
  null
  
)

export default component.exports